import { render, staticRenderFns } from "./newPublicHolidayGroup.vue?vue&type=template&id=2640cbe6&"
import script from "./newPublicHolidayGroup.vue?vue&type=script&lang=js&"
export * from "./newPublicHolidayGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2640cbe6')) {
      api.createRecord('2640cbe6', component.options)
    } else {
      api.reload('2640cbe6', component.options)
    }
    module.hot.accept("./newPublicHolidayGroup.vue?vue&type=template&id=2640cbe6&", function () {
      api.rerender('2640cbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Holiday/PublicHolidayGroup/newPublicHolidayGroup.vue"
export default component.exports